
const data = {
    "manualAbtest": true,
    "SITE": 1,
    "sogoujj":1,
    "pageAbtest": true,
    "CPS": 0,
    "pagePopverAbtest": true,
    "attrAbtest": true,
    "attrPopverAbtest": true,
    "manualImage": "//gw.alicdn.com/tfs/TB1rX4nGFOWBuNjy0FiXXXFxVXa-621-382.png",
    "callAttrRegex": "m.1688.com",
    "cosite": "sogoujj",
    "isConfirm": true,
    "manualPopverAbtest": true,
    "SEM": 0,
    "SEO": 0,
    "SEMLIST": "",
    "redPackage":true,
    "popverImage": "//gw.alicdn.com/tfs/TB1rX4nGFOWBuNjy0FiXXXFxVXa-621-382.png",
    "popverImageWidth":"88vw",
    "popverImageText":"需要登录查看更多内容使用支付宝快捷登录",
    "popverImageTextWidth":"38vw",
    "manualImageTextWidth":"38vw",
    "manualImageWidth":"88vw",
    "manualImageText":"我是手动唤起的文本哦"
};
export default {
    content: {
        "useCache": false,
        "traceId": "0b83deba15313199408096415e33ec",
        "data": [{
            "errorMsgs": "[]",
            "versionContent": data,
            "crocoServerTime": 1531319940820
        }]
    },
    success: true
}






// WEBPACK FOOTER //
// ./src/mock.js